import * as React from "react";
const SvgPause = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M6 4H10V20H6V4ZM14 4H18V20H14V4Z", fill: "#474749" }));
export default SvgPause;
